module.exports = __webpack_public_path__ + "static/img/list2.d879c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/longda/list2.png
// module id = Pqy1
// module chunks = 39